/* eslint-disable import/no-duplicates */
import React from 'react';
import PropTypes from 'prop-types';
import * as Mask from 'constants/mask';
import {BAR_SERIES} from 'constants/series-type';
import {BAR_STEP_SERIES} from 'constants/series-type';
import {CLUSTERED_COLUMN_SERIES} from 'constants/series-type';
import {COLUMN_SERIES} from 'constants/series-type';
import {COLUMN_STEP_SERIES} from 'constants/series-type';
import {DIFFERENCE_BAR_SERIES} from 'constants/series-type';
import {DIFFERENCE_COLUMN_SERIES} from 'constants/series-type';
import {DOT_SERIES} from 'constants/series-type';
import {LINE_SERIES} from 'constants/series-type';
import {STACKED_COLUMN_SERIES} from 'constants/series-type';
import LegendBarIcon from 'components/legend-bar-icon';
import LegendDotIcon from 'components/legend-dot-icon';
import LegendLineIcon from 'components/legend-line-icon';
import LegendStepIcon from 'components/legend-step-icon';
import {getHeight, getWidth} from 'utils/layout-util';
import './index.css';

export default class LegendIcon extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    mask: PropTypes.oneOf(Object.values(Mask)),
    style: PropTypes.object,
    type: PropTypes.oneOf([
      BAR_SERIES,
      BAR_STEP_SERIES,
      CLUSTERED_COLUMN_SERIES,
      COLUMN_SERIES,
      COLUMN_STEP_SERIES,
      DIFFERENCE_BAR_SERIES,
      DIFFERENCE_COLUMN_SERIES,
      DOT_SERIES,
      LINE_SERIES,
      STACKED_COLUMN_SERIES,
    ]),
    width: PropTypes.number,
  };

  static defaultProps = {
    height: 14,
    mask: '',
    type: COLUMN_SERIES,
    width: 28,
  };

  getIcon(type) {
    switch (type) {
      case COLUMN_STEP_SERIES:
        return LegendStepIcon;
      case DOT_SERIES:
        return LegendDotIcon;
      case LINE_SERIES:
        return LegendLineIcon;
      default:
        return LegendBarIcon;
    }
  }

  getStyle(type, style) {
    if (type && style) {
      switch (type) {
        case LINE_SERIES:
          return {
            stroke: style.stroke,
          };
        default:
          return {
            fill: style.fill,
            stroke: style.stroke || null,
          };
      }
    }
    return {};
  }

  render() {
    const Icon = this.getIcon(this.props.type);
    const height = getHeight(this.props.height);
    const style = this.getStyle(this.props.type, this.props.style);
    const width = getWidth(this.props.width);
    return Icon ? (
      <Icon
        height={height}
        mask={this.props.mask}
        style={style}
        width={width}
      />
    ) : null;
  }
}
